<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Modifier une FAQ</strong>
          </div>
            <b-form-group
              label="Question"
              label-for="question"
            >
            	<b-form-input id="question" type="text" :class="{hasError: errors.question !== ''}" v-model="question"></b-form-input>
              <span class="field-error">{{ errors.question }}</span>
            </b-form-group>

            <b-form-group>
                <editor :content.sync="contentForEditor" useCustomImageHandler @image-added="handleImageAdded"></editor>
                <span class="field-error">{{ errors.contentForEditor }}</span>
            </b-form-group>


            <b-form-group label="Type" label-for="basicSelect">
                <b-form-select
                    id="basicSelect"
                    :plain="true"
                    :options="[
                        {text: 'Questions générales', value: 'QG'},
                        {text: 'Rente invalidité', value: 'INVAL'},
                        {text: 'Rente conjoint, éducation', value: 'COED'}
                    ]"
                    v-model="selectedType">
                </b-form-select>
            </b-form-group>
            
            <div slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"></i> Liste des FAQ
              </b-button>
              <b-button type="button" @click="edit" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"></i> Enregistrer
              </b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "@/utils/auth"
import Editor from '../../../../components/Editor.vue'

export default {
  components: {
    Editor
  },
  data() {
  	return {
      id : '',
      reponse: '',
      question: '',
      contentForEditor: '',
      selectedType: '',
      errors: {
        question: '',
        reponse: '',
        contentForEditor: ''
      },
      contentForEditor: '<h5>La FAQ n\'a pas réussi à être chargée</h5>'
  	};
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
    this.get();
  },
  methods: {
    get() {
      this.$store.commit('IS_LOADING', true)
      let id = this.$route.params.id;
      let self = this;
       this.$axios
        .get("/espaceBeneficiaire/adminfaq/" + id)
        .then(response => {
          this.id = response.data.adminFaq.id;
          this.question = response.data.adminFaq.question;
          this.contentForEditor = response.data.adminFaq.reponse;
          this.selectedType = response.data.adminFaq.type;
          this.$store.commit('IS_LOADING', false)
          console.log(this.contentForEditor)
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          if(error.response && error.response.status === 404 && self != undefined){
            self.$router.push({ path: '/espace-beneficiaire/gestion-des-faq' })
            self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',showConfirmButton: false, timer: 5000})
          }
        });
    },
    edit() {
      if (this.validateData()) {
        this.$store.commit('IS_LOADING', true)
        let self = this;
        let id = this.$route.params.id;
        let dataPost = {};
        dataPost.question = this.question;
        dataPost.reponse = this.contentForEditor;
        dataPost.type = this.selectedType;

        this.$axios
          .put("/espaceBeneficiaire/adminfaq/edit/"+id, dataPost)
          .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Modification de la FAQ avec succès', text:'La FAQ a bien été modifiée',showConfirmButton: false, timer: 5000})
              this.returnBack()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',showConfirmButton: false, timer: 5000})
          });
      }
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        var formData = new FormData()
        formData.append('file', file)
        let self = this

        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/espaceBeneficiaire/adminfaq/upload', formData, config).then((response) => {
          let url = response.data.url
          Editor.insertEmbed(cursorLocation, 'image', url)
          resetUploader();
        }).catch(function () {
            self.$store.commit('IS_LOADING', false)
            self.$swal( {
                position: 'top',
                type: 'error',
                title: 'Attention',
                text: 'Un problème est survenu pendant le chargement de l\'image',
                showConfirmButton: false,
                timer: 0
            })
        })
    },
    returnBack() {
      this.$router.push({ path: '/espace-beneficiaire/gestion-des-faq' })
    },
    validateData () {
      this.clearErrors();
      let regEmail = this.$store.getters.getRegMail
      let regAlpha = this.$store.getters.getRegAlpha
      let valid = true;

      if (this.question === "") {
        this.errors.question = "La question est obligatoire";
        valid= false;
      } 
    //   else if (this.question.length > 90) {
    //      valid = false
    //      this.errors.question = 'Veuillez entrer une question valide'
    //   }

    //   if (this.reponse === "") {
    //     this.errors.reponse = "La réponse est obligatoire";
    //     valid= false;
    //   } 
    //   else if (this.reponse.length > 90) {
    //      valid = false
    //      this.errors.reponse = 'Veuillez entrer une réponse valide'
    //   }

      if (this.contentForEditor === "") {
        this.errors.contentForEditor = "La réponse est obligatoire";
        valid= false;
      } 

      return valid;
    },
    clearErrors() {
      this.errors.question = "";
      this.errors.reponse = "";
    }
  }
};
</script>

<style>
</style>
